import { render, staticRenderFns } from "./OmniSidebar.vue?vue&type=template&id=f9f19376&"
import script from "./OmniSidebar.vue?vue&type=script&lang=js&"
export * from "./OmniSidebar.vue?vue&type=script&lang=js&"
import style0 from "./OmniSidebar.vue?vue&type=style&index=0&id=f9f19376&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports